<template>
    <v-dialog v-model="dialog" max-width="500" @click:outside="hide">
        <v-card class="card-container">
            <v-card-title class="title-container">
                <v-icon color="#FFFFFF" @click="hide" large class="mr-3">mdi-close-circle-outline</v-icon>
                {{ $t('common.add') }} {{ $t('common.activity') }}
            </v-card-title>
            <v-card-text class="mt-3">
                <v-row dense>
                    <v-col cols="12">
                        <kimsa-text-field :label="$t('common.activity')" @change="name = $event" :value="name" outlined
                            dense no-elevation />
                    </v-col>
                    <v-col cols="12">
                        <kimsa-text-field :label="$t('common.time')" @change="time = $event" :value="time" outlined
                            dense no-elevation />
                    </v-col>
                    <v-col cols="12">
                        <kimsa-text-field :label="$t('common.intensity')" @change="intensity = $event"
                            :value="intensity" outlined dense no-elevation />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions class="px-0 pb-0">
                <v-btn block depressed x-large color="primary" class="normal-btn black--text no-radius"
                    :disabled="disabled" @click="save" :loading="loading">
                    {{ $t('common.save') }}
                </v-btn>
            </v-card-actions>
        </v-card>

    </v-dialog>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { db, Timestamp } from "@/utils/Firebase";
import KimsaTextField from '../common/inputs/KimsaTextField.vue';

export default {
    name: "AddActivityDialog",
    components: { KimsaTextField },
    data() {
        return {
            dialog: false,
            loading: false,
            name: '',
            time: '',
            intensity: ''
        }
    },
    computed: {
        ...mapState(['dialogActive']),
        disabled(vm = this) {
            return !vm.name || !vm.time || !vm.intensity
        },
    },
    methods: {
        ...mapMutations(['setDialogActive']),
        show() {
            const vm = this
            vm.dialog = true
            vm.setDialogActive(true)
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.setDialogActive(false)
            vm.reset()
        },
        reset() {
            const vm = this
            vm.injury = null
            vm.name = ''
            vm.time = ''
            vm.intensity = ''
        },
        async save() {
            const vm = this
            vm.loading = true

            await vm.sendMessageToCoach()
            vm.toast(vm.$t('common.activity_sent'))

            vm.loading = false
            vm.hide()
        },
        async sendMessageToCoach() {
            const vm = this

            let message = `${vm.$t('common.recorded_activity')} \n${vm.$t('common.name')}: ${vm.name} \n${vm.$t('common.time')}: ${vm.time} \n${vm.$t('common.intensity')}: ${vm.intensity}`

            let studentId = vm.currentUser?.uid || null
            let coachId = vm.account?.studentSubscription?.coachId || null

            let chatRef = await db.collection('privateChats')
                .where('type', '==', 'coach_student')
                .where('participants', 'in', [[coachId, studentId]])
                .get()

            let chatId = null
            if (chatRef.docs.length > 0) {
                chatId = chatRef.docs[0].id
            } else {
                let newChat = await db.collection('privateChats').add({
                    type: 'coach_student',
                    participants: [coachId, studentId]
                })
                chatId = newChat.id
            }

            let payload = {
                message: message,
                from: studentId,
                read: false,
                timestamp: Timestamp.now(),
                type: 'text'
            }

            await db.collection('privateChats').doc(chatId).collection('messages').add(payload)
            await db.collection('privateChats').doc(chatId).update({ lastMessage: payload })
        },
    },
    watch: {
        dialogActive(val) {
            if (!val) this.hide()
        },
    }
}
</script>

<style scoped>
.card-container {
    border-radius: 8px;
    overflow: hidden;
}

.title-container {
    color: #FFFFFF;
    background: var(--v-backGroundPrimary-base);
}
</style>